import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

const cn = require('classnames');
const _ = require('lodash');
const availableRoles = {
    admin : 'Administrador',
    subdirector : 'Subdirector',
    coordinador : 'Coordinador',
    asesor : 'Ejecutivo PyME',
}
import { numberPadding } from '../../../utils/formatting';

import UserForm from './UserForm';
import PaginationTable from '../PaginationTable';

const PAGINATION_ITEMS = 10;

const paginateUsers = (users, tab) => {
    return _.chunk(Object.values(users).filter(user => {
        return user.role === tab;
    }), PAGINATION_ITEMS);
}

export default class UsersIndex extends React.Component {

    constructor(props) {
        super(props);
        this.openFormModal = this._openFormModal.bind(this);
        this.hideFormModal = this._hideFormModal.bind(this);
        this.openDeleteModal = this._openDeleteModal.bind(this);
        this.hideDeleteModal = this._hideDeleteModal.bind(this);
        this.setActiveTab = this._setActiveTab.bind(this);
        this.state = {
            activeTab : Object.keys(availableRoles)[0],
            showFormModal : false,
            paginatedUsers : paginateUsers(props.users.data || {}, Object.keys(availableRoles)[0])
        }
    }

    componentWillReceiveProps(props) {
        this.setState({
            paginatedUsers : paginateUsers(props.users.data, this.state.activeTab)
        });
        if( ! this.props.users.savedUser && props.users.savedUser) {
            if(this.state.editingUser === null) {
                this.refs.usersTable.changePage(this.state.paginatedUsers.length);    
            }
            this.refs.usersTable.highlight(props.users.savedUser);
            this.hideFormModal();
        }

        if( this.props.users.deleting &&  ! props.users.deleteting ) {
            if(props.users.error) {
                console.error(props.users.error);
            } else {
                this.props.applicationMessage('success', (
                    <div>
                        <i className="fa fa-fw fa-check"></i> Se eliminó al usuario {this.state.deletingUser.name} correctamente
                    </div>
                ));
                this.hideDeleteModal();
            }
        }
    }


    _setActiveTab(tab) {
        this.setState({ 
            activeTab : tab,
            paginatedUsers : paginateUsers(this.props.users.data, tab)
        });
    }

    _openFormModal(user) {
        this.props.clearSaveData();
        this.setState({
            showFormModal : true,
            editingUser : user
        });
    }

    _hideFormModal() {
        this.props.clearSaveData();
        this.setState({
            showFormModal : false
        });
    }

    _openDeleteModal(user) {
        this.setState({
            deletingUser : user
        });
    }

    _hideDeleteModal() {
        this.setState({
            deletingUser : undefined
        });
    }

    render() {

        const fetching = this.props.users.fetching;
        const activeTab = this.state.activeTab;
        const users = this.state.paginatedUsers || [];
        return (
            <div className="container">
                <ul className="nav nav-tabs">
                    {
                        Object.keys(availableRoles).map(key => (
                                <li className="nav-item" key={key}>
                                    <a href="#" className={cn('nav-link', {'active' : key === this.state.activeTab})} onClick={() => this.setActiveTab(key)}>
                                        {availableRoles[key]}
                                    </a>
                                </li>
                            )
                        )
                    }
                </ul>

                <div className="text-right">
                    <button className="btn btn-secondary my-2" onClick={() => this.openFormModal(null)}>
                        Nuevo {availableRoles[activeTab]}
                    </button>
                </div>
                {
                    fetching ?
                    <div className="text-center my-2">
                        <i className="fa fa-spinner fa-spin"></i> Cargando
                    </div>
                    : <UsersTable
                        ref="usersTable"
                        users={users}
                        activeTab={activeTab}
                        coordinations={this.props.coordinations}
                        territories={this.props.territories}
                        editUser={this.openFormModal}
                        deleteUser={this.openDeleteModal}/>                
                }
                
                <UserForm  
                    show={this.state.showFormModal}
                    hideModal={this.hideFormModal}
                    saveUser={this.props.saveUser}
                    role={activeTab}
                    roleName={availableRoles[activeTab]}
                    user={this.state.editingUser}
                    error={this.props.users.error ? this.props.users.error.response : {}}
                    coordinations={this.props.coordinations}
                    territories={this.props.territories}/>

                <Modal isOpen={this.state.deletingUser !== undefined} toggle={this.hideDeleteModal}>
                    <ModalHeader toggle={this.hideDeleteModal}>
                        Dar de baja
                    </ModalHeader>
                    <ModalBody>
                        <p className="text-justify">
                            ¿Está seguro que desea dar de baja al {availableRoles[activeTab]} {this.state.deletingUser ? this.state.deletingUser.name : null}?
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-secondary" onClick={this.hideDeleteModal}>Cancelar</button>
                        <button className="btn btn-danger ml-1" onClick={() => this.props.deleteUser(this.state.deletingUser)}>Sí, dar de baja</button>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }

}



class UsersTable extends React.Component {
    
    constructor(props) {
        super(props);
        this.changePage = this._changePage.bind(this);
        this.highlight = this._highlight.bind(this);
        this.removeHighlight = this._removeHighlight.bind(this);
        this.state = {
            current_page : 1,
            highlighted : []
        }
    }

    componentWillReceiveProps(props) {
        if(this.props.activeTab !== props.activeTab) {
            this.changePage(1);
        }
    }

    _changePage(page) {
        this.setState({
            current_page : page
        });
    }

    _highlight(user) {
        console.log('highligtin');
        this.setState(prevState => {
            return {
                highlighted : [...prevState.highlighted, user.id]
            }
            
        }, () => {
            setTimeout(() => {
                this.removeHighlight(user);
            }, 3000);
        });
    }

    _removeHighlight(user) {
        this.setState(prevState => {
            const original = [...prevState.highlighted];
            const idx = prevState.highlighted.indexOf(user.id);
            if(idx >= 0) {
                original.splice(idx, 1);
            }
            return {
                highlighted : original
            }
        });
    }

    render() {
        const users = this.props.users[this.state.current_page - 1] || [];
        const last_page = this.props.users.length;
        const activeTab = this.props.activeTab;

        if(users.length === 0) {
            return (
                <div className="alert alert-info">
                    No hay usuarios que mostrar
                </div>
            );
        }

        return (
            <PaginationTable
                territories={this.props.territories}
                coordinations={this.props.coordinations}
                activeTab={activeTab}
                editUser={this.props.editUser}
                deleteUser={this.props.deleteUser}
                highlightedUsers={this.state.highlighted}
                items={users}
                current_page={this.state.current_page}
                last_page={last_page}
                pageChange={this.changePage}
                headerComponent={renderUsersHeader}
                rowComponent={renderUserRow}/>
        );
    }
}

function renderUsersHeader(props) {
    const activeTab = props.activeTab;
    return (
        <tr>
            {
                activeTab !== 'admin' ? 
                <th>
                    Territorio
                </th>
                : null
            }
            {
                activeTab !== 'admin' && activeTab !== 'subdirector' ?
                <th>
                    Coordinación
                </th>
                : null
            }
            <th>
                Número de empleado
            </th>
            <th>
                Nombre
            </th>
            <th>
                Correo electrónico
            </th>
            <th>
            </th>
        </tr>
    );
}

function renderUserRow(props) {
    const user = props.item;
    const territory = props.territories.data[user.territory_id];
    const coordination = props.coordinations.data[user.coordination_id];
    const activeTab = props.activeTab;
    return (
        <tr key={user.id} className={cn({'table-inverse bg-info' : props.highlightedUsers.indexOf(user.id) >= 0})}>
            {
                activeTab !== 'admin' ? 
                <td>
                    {territory ? territory.name : null}
                </td>
                : null
            }
            {
                activeTab !== 'admin' && activeTab !== 'subdirector' ?
                <td>
                    {coordination ? coordination.name : null}
                </td>
                : null
            }
            
            <td>
                {numberPadding(user.emp_number, 6)}
            </td>
            <td>
                {user.name}
            </td>
            <td>
                {user.email}
            </td>
            <td>
                <button className="btn btn-secondary btn-sm" onClick={() => props.editUser(user)}><i className="fa fa-fw fa-pencil"></i> Editar</button>
                &nbsp;
                <button className="btn btn-danger btn-sm" onClick={() => props.deleteUser(user)}><i className="fa fa-fw fa-trash"></i> Baja</button>
            </td>
        </tr>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/users/UsersIndex.jsx
 **/